import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import AppHome from "@/views/AppHome/AppHome.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: AppHome,
    meta: {
      componentKey: "Home"
    }
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/AppAbout/AppAbout.vue"),
    meta: {
      componentKey: "About"
    }
  },
  {
    path: "/map/:mapId?",
    name: "KahiMap",
    component: () =>
      import(/* webpackChunkName: "map" */ "@/views/KahiMap/KahiMap.vue"),
    meta: {
      componentKey: "KahiMap"
    }
  },
  {
    path: "/list",
    name: "KahiList",
    component: () =>
      import(/* webpackChunkName: "list" */ "@/views/KahiList/KahiList.vue"),
    meta: {
      componentKey: "KahiList"
    }
  },
  {
    path: "/detail",
    redirect: {
      name: "Home"
    }
  },
  {
    path: "/detail/:detailId",
    name: "KahiDetail",
    component: () =>
      import(
        /* webpackChunkName: "detail" */ "@/views/KahiDetail/KahiDetail.vue"
      )
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const toPath: string = to.path;

  if (typeof from.name !== "undefined") {
    const fromPath: string = from.path;

    if (toPath === "/about") {
      store.commit("navigation/setAboutParentPage", fromPath);
    } else if (!/^\/detail\//.test(toPath)) {
      if (/^\/map/.test(toPath)) {
        store.commit("navigation/setDetailParentPage", "/map");
      } else {
        store.commit("navigation/setDetailParentPage", "/list");
      }
    }
  } else if (toPath === "/list") {
    store.commit("navigation/setDetailParentPage", toPath);
  } else if (/^\/map/.test(toPath)) {
    store.commit("navigation/setDetailParentPage", toPath);
  }

  if (/^\/detail\//.test(toPath)) {
    to.meta.componentKey = "KahiDetail" + to.params.detailId;
  }

  next();
});

router.afterEach((to, from) => {
  if (typeof from.name !== "undefined") {
    const toPath: string = to.path;
    const fromPath: string = from.path;
    let transition: string | null = null;

    if (toPath === "/about") {
      transition = "slide-up";
    } else if (fromPath === "/about") {
      transition = "slide-down";
    } else if (/^\/detail\//.test(toPath)) {
      transition = "slide-left";
    } else if (/^\/detail\//.test(fromPath)) {
      transition = "slide-right";
    } else {
      transition = "fade";
    }

    if (transition !== null) {
      to.meta.transition = transition;
    }
  }
});

export default router;
